(function () {
  var fidesHost = "https://privacy.condenastdigital.com/fides.js"; // Host could also be "https://stag.privacy.condenastdigital.com/fides.js" for staging.
  var fidesPropertyId = "FDS-G4JAFU"; // Example Property ID - FDS-TJM2IE
  var fidesSrc = fidesHost + "?property_id=" + fidesPropertyId + "&";

  var gtmOptions = {
    flag_type: "boolean",
    non_applicable_flag_mode: "include",
  };

  function setupShopifyBridge() {
    addEventListener("FidesProxy", function (proxiedEvent) {
      var shopify = window.Shopify || {};
      var analytics = shopify.analytics || {
        publish: function () {
          console.warn("Shopify's analytics publish could not be found.");
        },
      };
      analytics.publish(proxiedEvent.detail.event, proxiedEvent.detail.Fides);
    });

    window.dataLayer = window.dataLayer || [];
    var handleProxyDispatch = (...args) => {
      var event = (args || [])[0];
      var eventName = (event || {}).event || "";
      if (eventName.startsWith("Fides")) {
        var proxyEvent = new CustomEvent("FidesProxy", {
          detail: event,
        });
        window.dispatchEvent(proxyEvent);
      }
    };
    window.dataLayer.push = function (...args) {
      Array.prototype.push.apply(this, args);
      handleProxyDispatch.apply(this, args);
    };
  }

  function insertFidesScript() {
    addEventListener("FidesInitializing", function () {
      window.Fides.gtm(gtmOptions);
    });

    addEventListener("FidesInitialized", function () {
      window.Fides.shopify();
      try {
        var experience = window.Fides.experience || {};
        var config = experience.experience_config || {};
        var id = config.id;
        if (id) {
          window.document.body.classList.add(id);
        }
      } catch {
        console.warn("Couldn't apply Fides experience ID to body.");
      }
    });

    var fidesPrefix = "fides_";
    var searchParams = new URLSearchParams(location.search);
    var fidesSearchParams = new URLSearchParams();
    searchParams.forEach(function (key, value) {
      if (key.startsWith(fidesPrefix)) {
        fidesSearchParams.set(
          key.replace(fidesPrefix, ""),
          key === fidesPrefix + "cache_bust" ? Date.now().toString() : value
        );
      }
    });
    var src = fidesSrc + fidesSearchParams.toString();
    var script = document.createElement("script");
    script.async = false;
    script.defer = false;
    script.setAttribute("src", src);
    script.setAttribute("id", "fides-js");
    script.setAttribute("type", "text/javascript");
    document.head.appendChild(script);
    window.ethycaEnabled = true;
  }

  setupShopifyBridge();
  insertFidesScript();
})();
